export const isIOS = () => ({
	type: 'IS_IOS'
});

export const isNotIOS = () => ({
	type: 'IS_NOT_IOS'
});


// WEBPACK FOOTER //
// ./src/actions/ios.js